module.exports = __webpack_public_path__ + "static/media/s_2.62382413.mp3";